module.exports = __webpack_public_path__ + "static/media/preview.2380ea56.svg";